'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { HStack, Spacer } from '@/components/Layout';

import { InnerNavigation } from './-components/InnerNavigation';
import { ProgressCard } from './-components/ProgressCard';
import { SubscriptionContractForm } from './-components/SubscriptionContractForm';
import { SubscriptionContractFormStore } from './-store/subscriptionContractFormStore';

export const Route = createFileRoute('/_staff/contract/add/subscription/')({
  component: SubscriptionContractPage,
});

function SubscriptionContractPage() {
  const [store] = useState(() => SubscriptionContractFormStore.createStore());

  return (
    <SubscriptionContractFormStore.Provider value={store}>
      <HStack className="w-full p-6">
        <InnerNavigation />
        <Spacer variant="m" />
        <div className="pb-24 grow min-w-[340px]">
          <SubscriptionContractForm />
        </div>
        <Spacer variant="m" />
        <ProgressCard />
      </HStack>
    </SubscriptionContractFormStore.Provider>
  );
}
